






















































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import ImpersonateMenu from '@/components/ImpersonateMenu'
import OrganizerSettingsModal from '@ui/Organizer/OrganizerSettingsModal'

settings =
  name: 'Navbar'
  vue:
    store: [ 'member' ]
    components: {
      LoadingIndicator,
      ImpersonateMenu,
      OrganizerSettingsModal,
    }

    data: ->
      settingsModal:
        show: false

    computed:
      isExperiencesRoute: -> @$route.path.includes 'experiences'
      isOffersRoute: -> @$route.name.includes 'Offer'
      isShippingAreasRoute: -> @$route.name.includes 'Shipping'
      isRecapsRoute: -> @$route.name.includes 'Recap'
      isDashboardRoute: -> @$route.name.includes 'OrganizerDashboard'

    methods:
      hiSettings: ->
        @settingsModal.show = true

      handleDropdownActionClicked: (command) ->
        switch command
          when 'account' then @$router.push({ name : 'MeShowPage' })
          when 'logout' then @logout()

export default VueOptions.vue settings
